// Constants for the dynamic hiring document package flow (per Mudassir's Jun-16
// handoff). NOTE: the API returns the package/item *status* fields as numeric
// enums (confirmed live), even though the handoff doc wrote them as strings.
// nextAction, however, comes back as a camelCase string. So status enums are
// keyed by number; nextAction stays a string.

// Per-document "what to do next" helper (string). Use it to pick the FE control.
export const NextAction = Object.freeze({
  HrUploadTemplate: "hrUploadTemplate",
  ApplicantSubmit: "applicantSubmit",
  ApplicantAcknowledge: "applicantAcknowledge",
  HrVerify: "hrVerify",
  Completed: "completed",
  Waived: "waived",
});

// Document item collection workflow type (string).
export const CollectionMode = Object.freeze({
  HrSendsApplicantReturns: "HrSendsApplicantReturns",
  ApplicantUploadsOnly: "ApplicantUploadsOnly",
  HrVerificationRequired: "HrVerificationRequired",
  HrUploadsOnly: "HrUploadsOnly",
  SystemProvidedApplicantAcknowledges: "SystemProvidedApplicantAcknowledges",
});

// Overall package status (numeric enum, ordered per the handoff doc).
export const PackageStatus = Object.freeze({
  Draft: 0,
  SentToApplicant: 1,
  PendingHrVerification: 2,
  Completed: 3,
  Cancelled: 4,
});

export const PackageStatusLabel = Object.freeze({
  [PackageStatus.Draft]: "Draft",
  [PackageStatus.SentToApplicant]: "Sent to Applicant",
  [PackageStatus.PendingHrVerification]: "Pending HR Verification",
  [PackageStatus.Completed]: "Completed",
  [PackageStatus.Cancelled]: "Cancelled",
});

export const PackageStatusColor = Object.freeze({
  [PackageStatus.Draft]: "default",
  [PackageStatus.SentToApplicant]: "blue",
  [PackageStatus.PendingHrVerification]: "gold",
  [PackageStatus.Completed]: "green",
  [PackageStatus.Cancelled]: "red",
});

// Per-document item status (numeric enum, ordered per the handoff doc).
export const ItemStatus = Object.freeze({
  PendingHrUpload: 0,
  PendingApplicantSubmit: 1,
  PendingHrVerification: 2,
  Completed: 3,
  Waived: 4,
});

export const ItemStatusLabel = Object.freeze({
  [ItemStatus.PendingHrUpload]: "Pending HR Upload",
  [ItemStatus.PendingApplicantSubmit]: "Pending Applicant Submit",
  [ItemStatus.PendingHrVerification]: "Pending HR Verification",
  [ItemStatus.Completed]: "Completed",
  [ItemStatus.Waived]: "Waived",
});

export const ItemStatusColor = Object.freeze({
  [ItemStatus.PendingHrUpload]: "gold",
  [ItemStatus.PendingApplicantSubmit]: "blue",
  [ItemStatus.PendingHrVerification]: "orange",
  [ItemStatus.Completed]: "green",
  [ItemStatus.Waived]: "default",
});
